import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';

interface Window {
  dataLayer?: any[];
}


@Injectable({
  providedIn: 'root'
})
export class ScriptsInjectorService {
  private isBrowser: boolean = false;
  private trackingContainer: HTMLElement | null = null;
  private addedTags: Set<string> = new Set();
  private injectedScripts: Set<string> = new Set();

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: Document,
    private sanitizer: DomSanitizer


  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);


  }


  // initializeJornaya(token1: string, token2: string): void {
  //   if (!this.isBrowser) return;

  //   this.logJornayaDebug('scripts-injector:initializeJornaya:called', {
  //     token1Len: (token1 || '').length,
  //     token2Len: (token2 || '').length,
  //   });

  //   if (document.getElementById('LeadiDscript_campaign')) {
  //     this.logJornayaDebug('scripts-injector:initializeJornaya:skipped-existing-campaign');
  //     return;
  //   }

  //   const noscript = document.createElement('noscript');
  //   noscript.id = 'LeadiDscript_noscript';
  //   const img = document.createElement('img');

  //   if (document.getElementById('LeadiDscript_noscript')) {
  //     this.logJornayaDebug('scripts-injector:initializeJornaya:skipped-existing-noscript');
  //     return;
  //   }

  //   img.src = `//create.leadid.com/noscript.gif?lac=${token2}&lck=${token1}&snippet_version=2`;
  //   noscript.appendChild(img);
  //   document.body.appendChild(noscript);
  //   this.logJornayaDebug('scripts-injector:initializeJornaya:inserted-noscript', {
  //     src: img.src,
  //   });
  // }  

  initializeTrustedForm(field: string = 'xxTrustedFormCertUrl', provideReferrer: boolean = false): void {
    if (!this.isBrowser) return;

    const trustedFormScript = document.querySelector('script[src*="api.trustedform.com/trustedform.js"]');
    if (trustedFormScript || document.getElementById('trustedform-loader-script')) return;

    const script = document.createElement('script');
    script.id = 'trustedform-loader-script';
    script.type = 'text/javascript';
    script.text = `
      (function() {
        var field = '${field}';
        var provideReferrer = ${provideReferrer};
        var tf = document.createElement('script');
        tf.id = 'trustedform-script';
        tf.type = 'text/javascript'; 
        tf.async = true;
        tf.src = 'https://api.trustedform.com/trustedform.js?provide_referrer=' + escape(provideReferrer) + 
          '&field=' + escape(field) + '&l=' + new Date().getTime() + Math.random();
        var s = document.getElementsByTagName('script')[0]; 
        s.parentNode.insertBefore(tf, s);
      })();
    `;

    const noscript = document.createElement('noscript');
    noscript.id = 'trustedform-noscript';
    const img = document.createElement('img');

    if (!document.getElementById('trustedform-noscript')) {
      img.src = 'https://api.trustedform.com/ns.gif';
      noscript.appendChild(img);
      document.body.appendChild(noscript);
    }

    document.body.appendChild(script);
  }

  private isDebugJornayaEnabled(): boolean {
    const search = this.document?.location?.search || '';
    if (!search) return false;
    const value = new URLSearchParams(search).get('debugJornaya')?.trim().toLowerCase();
    return value === '1' || value === 'true' || value === 'yes';
  }

  private logJornayaDebug(stage: string, details: Record<string, unknown> = {}): void {
    if (!this.isDebugJornayaEnabled()) return;
    console.log(`[JORNAYA-DEBUG][scripts-injector] stage=${stage}`, details);
  }

  _initializeGTM(
    gtmId: string,
    accountId: string,
    containerId: string,
    dataLayerName: string = 'dataLayer'
  ): void {
    if (!this.isBrowser) return;

    const dataLayerScript = document.createElement('script');
    dataLayerScript.type = 'text/javascript';
    dataLayerScript.text = `
      ${dataLayerName} = [{
        'a': '${accountId}',
        'i': '${containerId}'
      }];
    `;
    document.body.appendChild(dataLayerScript);

    const noscript = document.createElement('noscript');
    const iframe = document.createElement('iframe');
    iframe.src = `//www.googletagmanager.com/ns.html?id=${gtmId}`;
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    noscript.appendChild(iframe);
    document.body.appendChild(noscript);

    const gtmScript = document.createElement('script');
    gtmScript.type = 'text/javascript';
    gtmScript.text = `
      (function(w, d, s, l, i) {
        w[l] = w[l] || []; w[l].push({
          'gtm.start': new Date().getTime(),
          event: 'gtm.js'
        });
        var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s),
            dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = '//www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', '${dataLayerName}', '${gtmId}');
    `;
    document.body.appendChild(gtmScript);
  }

  initializeGTM(
    gtmId: string,
    accountId: string,
    containerId: string,
    businessName: string,
    templateName: string,
    dataLayerName: string = 'dataLayer'
  ): void {
    if (!this.isBrowser) return;

    const dataLayerScript = document.createElement('script');
    dataLayerScript.type = 'text/javascript';
    dataLayerScript.text = `
      ${dataLayerName} = [{
        'a': '${accountId}',
        'i': '${containerId}',
        'b': '${businessName}',
        't': '${templateName}'
      }];
    `;
    document.body.appendChild(dataLayerScript);

    const noscript = document.createElement('noscript');
    const iframe = document.createElement('iframe');
    iframe.src = `//www.googletagmanager.com/ns.html?id=${gtmId}`;
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    noscript.appendChild(iframe);
    document.body.appendChild(noscript);

    const gtmScript = document.createElement('script');
    gtmScript.type = 'text/javascript';
    gtmScript.text = `
      (function(w, d, s, l, i) {
        w[l] = w[l] || []; w[l].push({
          'gtm.start': new Date().getTime(),
          event: 'gtm.js'
        }); var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
            '//www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
      })(window, document, 'script', '${dataLayerName}', '${gtmId}');
    `;
    document.body.appendChild(gtmScript);
  }

}
